import { Loader2, RefreshCw } from 'lucide-react'
import type { I2VResponse } from '../../types/director_v2'

interface StoryboardTimelineProps {
  i2vResult: I2VResponse
  videoRefineInput: string
  setVideoRefineInput: (v: string) => void
  isRefiningVideo: boolean
  onRefineVideoPrompt: (originalVideoPrompt: string) => void
}

export function StoryboardTimeline({
  i2vResult,
  videoRefineInput, setVideoRefineInput,
  isRefiningVideo, onRefineVideoPrompt,
}: StoryboardTimelineProps) {
  const isSingleSegment = !i2vResult.storyboard.part_2_10_to_20s

  return (
    <div className="bg-gray-800 rounded-lg p-3 border border-gray-700">
      <h2 className="text-base font-semibold mb-2">📽️ 第四步：查看分镜剧本</h2>
      <div className="mb-3 p-2 bg-blue-900/30 border border-blue-700 rounded-lg">
        <h3 className="font-semibold mb-1 text-sm">导演解读</h3>
        <p className="text-gray-300 text-xs">{i2vResult.director_analysis}</p>
      </div>
      <div className="space-y-2">
        {[
          { key: 'part_1_0_to_10s', label: '0-10秒', part: i2vResult.storyboard.part_1_0_to_10s },
          { key: 'part_2_10_to_20s', label: '10-20秒', part: i2vResult.storyboard.part_2_10_to_20s },
          { key: 'part_3_20_to_30s', label: '20-30秒', part: i2vResult.storyboard.part_3_20_to_30s },
        ]
          .filter((item) => item.part && item.part.action_summary && item.part.video_prompt)
          .map((item) => (
            <div key={item.key} className="bg-gray-700 p-2 rounded-lg">
              <div className="flex justify-between items-start mb-1.5">
                <h3 className="font-semibold text-sm">{item.label}</h3>
                <button
                  onClick={() => navigator.clipboard.writeText(item.part!.video_prompt)}
                  className="px-2 py-0.5 bg-green-600 hover:bg-green-700 rounded text-xs transition-colors"
                >
                  📋 复制提示词
                </button>
              </div>
              <div className="bg-gray-800 p-2 rounded border border-gray-600">
                <pre className="text-xs text-gray-300 whitespace-pre-wrap">{item.part!.video_prompt}</pre>
              </div>

              {/* Refine input - only for 10s single segment mode */}
              {isSingleSegment && item.key === 'part_1_0_to_10s' && (
                <div className="mt-2 flex gap-2">
                  <input
                    type="text"
                    value={videoRefineInput}
                    onChange={(e) => setVideoRefineInput(e.target.value)}
                    placeholder="输入调整意见，例如：镜头再慢一点 / 加入雨滴效果 / 动作幅度更大"
                    className="flex-1 px-2 py-1.5 bg-gray-600 border border-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white text-sm"
                    disabled={isRefiningVideo}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && videoRefineInput.trim()) {
                        onRefineVideoPrompt(item.part!.video_prompt)
                      }
                    }}
                  />
                  <button
                    onClick={() => onRefineVideoPrompt(item.part!.video_prompt)}
                    disabled={isRefiningVideo || !videoRefineInput.trim()}
                    className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed rounded-lg font-medium transition-colors text-sm whitespace-nowrap flex items-center"
                  >
                    {isRefiningVideo ? (
                      <><Loader2 className="w-3 h-3 mr-1 animate-spin" />优化中...</>
                    ) : (
                      <><RefreshCw className="w-3 h-3 mr-1" />重新生成</>
                    )}
                  </button>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  )
}
